export default __webpack_public_path__ + "static/media/csv_sheet.9f8ed16b.png";